"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IbanPaymentMethodModel = exports.PaymentMethodModel = void 0;
const validator_1 = require("@leavy/validator");
const PaymentMethodType_1 = require("../domain/PaymentMethodType");
/**
 * Base model for a payment method
 */
class PaymentMethodModel {
}
__decorate([
    (0, validator_1.IsEnum)(PaymentMethodType_1.PaymentMethodType),
    __metadata("design:type", String)
], PaymentMethodModel.prototype, "type", void 0);
exports.PaymentMethodModel = PaymentMethodModel;
/**
 * Model for an IBAN payment method
 */
class IbanPaymentMethodModel extends PaymentMethodModel {
    constructor() {
        super(...arguments);
        /**
         * The discriminator to determine the type of payment method.
         * @type {PaymentMethodType.IBAN}
         */
        this.type = PaymentMethodType_1.PaymentMethodType.IBAN;
    }
}
__decorate([
    (0, validator_1.Equals)(PaymentMethodType_1.PaymentMethodType.IBAN),
    __metadata("design:type", String)
], IbanPaymentMethodModel.prototype, "type", void 0);
__decorate([
    (0, validator_1.IsString)(),
    (0, validator_1.IsIBAN)(),
    __metadata("design:type", String)
], IbanPaymentMethodModel.prototype, "iban", void 0);
__decorate([
    (0, validator_1.IsString)(),
    (0, validator_1.IsBIC)(),
    __metadata("design:type", String)
], IbanPaymentMethodModel.prototype, "bic", void 0);
exports.IbanPaymentMethodModel = IbanPaymentMethodModel;
//# sourceMappingURL=PaymentMethod.js.map